import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ListAdministratorComponent } from 'app/home/paraEmpresas/administration/list/content.component';
import { EditAdministratorComponent } from 'app/home/paraEmpresas/administration/save/content.component';
import { AbbreviatedDialingComponent } from 'app/home/paraEmpresas/administration/abbreviatedDialing/content.component';
import { CarrierMember } from 'app/models/carrier.model';
import { ServiceMember } from 'app/models/serviceMember.model';
import { BindComponentService } from 'app/utils/bind.component.service';
import { LoadingComponent } from '../modalLoading/content.component';
import { AdministrationService } from 'app/services/administration.service';
import { AlertService } from 'app/utils/alert.service';
import { AuthenticationService } from '../../../../app/services/authentication.service';

/**
 * @author Wesley Mascarenhas
 * @version $Id: content.component.ts 81709 2018-03-09 04:19:01Z thiago.h.neri $
 */
@Component({
  templateUrl: './content.template.html'
})
export class AdministrationComponent implements OnInit {

  private filterValue: string = '';
  private hasAbbreviatedDialingService: boolean  = false;
  private contractNumber: string = '';
  private serviceMemberList: Array<ServiceMember> = [];
  private carrierList: Array<CarrierMember> = [];
  private preferentialCSP: ServiceMember;
  private AbbreviatedDialingServiceName: string = 'RAM_EXT';
  private loggedManagerType: string;

  @ViewChild(ListAdministratorComponent) listAdminComponent: ListAdministratorComponent;
  constructor(private modalService: NgbModal, private bindComponent: BindComponentService, private adminService: AdministrationService, private alertService: AlertService,private authService : AuthenticationService ) {
  }
  
  ngOnInit() {
    this.bindComponent.set(BindComponentService.FILTER_ACTIVE_TAB, 'ADMIN_FILTER'); //ALTERADO
    this.loadView();
  }

  private loadView(): void {
    this.loggedManagerType ="";
    let data = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    this.loggedManagerType = data['loggedManagerType'];
    this.listAdminComponent.loadView();
  }

  private filter() {
    this.listAdminComponent.setFilter(this.filterValue);
  }

  private openCreateModal() {
    let modalRef = this.modalService.open(EditAdministratorComponent, { backdrop: 'static' });
    modalRef.componentInstance.model = {};
    modalRef.componentInstance.groups = this.listAdminComponent['groups'];
    modalRef.componentInstance.hasData = this.listAdminComponent['hasData'];
    modalRef.result.then(result => this.loadView(), reason => this.loadView());
  }
  
  private openAbbreviatedDialingModal() {
    this.openModalLoading();
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,true);
    this.adminService.getAbbreviatedData(this.AbbreviatedDialingServiceName, this.listAdminComponent['contractNumber']).subscribe(
      data => {
        this.serviceMemberList = data['serviceMemberList'];
        this.carrierList = data['carrierList'];
        this.preferentialCSP = data['preferentialCSP'];
        this.serviceMemberList.forEach(serviceMember => {
          serviceMember.editing = false;
          serviceMember.edited = false;
        });
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
        let modalRef = this.modalService.open(AbbreviatedDialingComponent, { backdrop: 'static' });
        modalRef.componentInstance.serviceName = this.AbbreviatedDialingServiceName;
        modalRef.componentInstance.contractNumber = this.listAdminComponent['contractNumber'];
        modalRef.componentInstance.serviceMemberList = this.serviceMemberList;
        modalRef.componentInstance.carrierList = this.carrierList;
        modalRef.componentInstance.preferentialCSP = this.preferentialCSP;
      },
      err => {
        this.alertService.error(err.result, err);
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
      }
    );
  }  

  private openModalLoading() {
    this.modalService.open(LoadingComponent,{  
      backdrop: 'static',    
      keyboard: false ,
    });
  }

  private mouseEnter() {
    setTimeout(() => {
      document.getElementsByClassName("popover-top")[0].classList.add("popover-big");
    }, 1);
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/administration/content.component.ts